import { EntityId } from "@reduxjs/toolkit";
import axios from "axios";

export interface AdminAccount {
  id: EntityId;
  username: string;
  password: string;
}

export const adminAPI = {
  async login(acc: Omit<AdminAccount, "id">) {
    await axios.post(`${process.env.REACT_APP_BACKEND_URL}/admin/login`, acc, {
      withCredentials: true,
    });
  },
  async checkSession() {
    await axios.get(`${process.env.REACT_APP_BACKEND_URL}/session`, {
      withCredentials: true,
    });
  },
  async logout() {
    await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/admin/logout`, {
      withCredentials: true,
    });
  },
  async register(acc: Omit<AdminAccount, "id">) {
    await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/admin/register`,
      acc,
      {
        auth: {
          username:
            process.env.REACT_APP_BACKEND_BASIC_USERNAME ?? "defaultuser",
          password:
            process.env.REACT_APP_BACKEND_BASIC_PASSWORD ?? "defaultpass",
        },
      }
    );
  },
};
